<template>
    <div/>
</template>

<script>
import Vue from 'vue'
import User from '@/User'

/** Special page to log user out - only for use in Cypress tests. */
export default Vue.extend({
    name: 'UserLogout',
    async created () {
        User.logoutUser(this)
    }
})
</script>
